export const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
export const phonePattern = /^\+(?:[0-9] ?){10}[0-9]$/
